import { render, staticRenderFns } from "./ColorAdd.vue?vue&type=template&id=6d2ccb00&scoped=true&"
import script from "./ColorAdd.vue?vue&type=script&lang=js&"
export * from "./ColorAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2ccb00",
  null
  
)

export default component.exports